module.exports = __webpack_public_path__ + "img/3-11-3.444ad56e.png";